import React from 'react';
interface PanelProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  bodyClassName?: string;
}
export function Panel({
  title,
  subtitle,
  actions,
  children,
  className = '',
  bodyClassName = 'p-5'
}: PanelProps) {
  return <section className={`rounded-lg border border-border bg-card shadow-sm ${className}`} data-id="element-149" data-mp="1wx1benzon841">
      {(title || actions) && <header className="flex flex-wrap items-center justify-between gap-3 border-b border-border px-5 py-3.5" data-id="element-150" data-mp="2tlh1qmam9li7">
          <div data-id="element-151" data-mp="2op8pphrpu8f9">
            {title && <h2 className="font-heading text-[15px] font-semibold text-navy-900" data-id="element-152" data-mp="2jw7b7avf8aw7">{title}</h2>}
            {subtitle && <p className="mt-0.5 text-xs text-muted-foreground" data-id="element-153" data-mp="2fvdo2jpsz04d">{subtitle}</p>}
          </div>
          {actions && <div className="flex flex-wrap items-center gap-2" data-id="element-154" data-mp="3cd036oozsri4">{actions}</div>}
        </header>}
      <div className={bodyClassName} data-id="element-155" data-mp="37lrszqfu923w">{children}</div>
    </section>;
}